/**
 * @format
 */

export default {
  x: {},
};
